<template>
  <b-col cols="12">
    <b-overlay :show="processingTraceabilityGetter" rounded="sm">
      <b-table
        responsive
        small
        :items="traceabilityGetter.data"
        :fields="fields"
        hover
        selectable
        @row-selected="onRowSelected"
        caption-top
        ref="tableManagement"
        stacked="sm"
      >
        <template v-if="beginRetraction" #cell(selected)="{ rowSelected }">
          <img
            :src="
              require(`@/assets/modules/permisos-sindicales/icons/tables/${
                rowSelected ? 'checkbox-selected' : 'checkbox'
              }.svg`)
            "
            :alt="rowSelected ? 'checkbox-selected' : 'checkbox'"
          />
        </template>

        <template #cell(show_details)="row">
          <span
            v-if="row.item.audits.length > 1"
            @click.prevent="row.toggleDetails"
          >
            <img
              :src="
                require('@/assets/modules/permisos-sindicales/icons/tables/arrow-down-s-fill.svg')
              "
              alt="details"
            />
          </span>
        </template>

        <template #row-details="{ item }">
          <b-row class="mb-2">
            <b-col cols="2" class="text-right"><b></b></b-col>
            <b-col class="ml-5">
              <table class="table-simple">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(element, key) in separateAudits(item).others"
                    :key="'audit'.concat(key)"
                  >
                    <td>
                      <img
                        :src="
                          require(`@/assets/modules/permisos-sindicales/icons/${element.status}.svg`)
                        "
                        :alt="element.status"
                      />
                      {{ formatStateManagement(element) }}
                    </td>
                    <td style="min-width: 100%"></td>
                    <td>
                      {{ formatUpdateAt(element.updated_at) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </template>

        <template #cell(management)="{ item }">
          <img
            :src="
              require(`@/assets/modules/permisos-sindicales/icons/${
                separateAudits(item).first.status
              }.svg`)
            "
            :alt="separateAudits(item).first.status"
          />
          {{ formatStateManagement(separateAudits(item).first) }}
        </template>

        <template #cell(updated_at)="{ item }">
          {{ formatUpdateAt(separateAudits(item).first.updated_at) }}
        </template>
      </b-table>
      <vue-pagination
        class="pagination-center"
        :data="traceabilityGetter"
        :limit="5"
        @pagination-change-page="changePage"
      />
    </b-overlay>
  </b-col>
</template>

<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<style lang="scss" src="./styles.scss" />
